import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

const TwoFaExpiredDialog = ({ open, onConfirm }) => {
  return (
    <Dialog
      open={open}
      maxWidth='xs'
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
          zIndex: (theme) => theme.zIndex.modal + 2, // Make this dialog appear above all items
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ShieldOutlinedIcon color='warning' sx={{ fontSize: 24 }} />
          <Typography
            variant='h6'
            component='div'
            sx={{ fontWeight: 600, color: "warning.main" }}
          >
            Two-factor verification expired
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant='body1' color='text.secondary' sx={{ mt: 1 }}>
          Your two-factor authentication session has expired. Please sign in
          again and complete verification to continue.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onConfirm}
          variant='contained'
          color='primary'
          fullWidth
          sx={{
            borderRadius: 1,
            textTransform: "none",
            px: 3,
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
              backgroundColor: "primary.dark",
            },
          }}
        >
          Log in again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TwoFaExpiredDialog;
